import { useEffect, useState } from "react";
import api from "@/lib/api";

export default function AdminContacts() {
  const [items, setItems] = useState([]);
  const [selected, setSelected] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    api.get("/admin/contacts").then((r) => {
      setItems(r.data);
      setLoading(false);
    });
  }, []);

  return (
    <div className="space-y-6">
      <div>
        <div className="text-[10px] uppercase tracking-[0.28em] text-slate-500">Contact inbox</div>
        <h1 className="font-display text-3xl md:text-4xl tracking-tighter font-medium mt-2">Incoming contact requests</h1>
      </div>

      <div className="grid md:grid-cols-5 gap-6">
        <div className="md:col-span-2 bg-white border border-slate-200 max-h-[70vh] overflow-auto mp-scroll">
          {loading && <div className="p-6 text-slate-400 text-sm">Loading…</div>}
          {!loading && items.length === 0 && (
            <div className="p-6 text-slate-400 text-sm">No contact submissions.</div>
          )}
          {items.map((c) => (
            <button
              key={c.id}
              data-testid={`contact-item-${c.id}`}
              onClick={() => setSelected(c)}
              className={`block w-full text-left px-4 py-3 border-b border-slate-100 hover:bg-slate-50 ${
                selected?.id === c.id ? "bg-slate-50 border-l-2 border-l-[#1E40AF]" : ""
              }`}
            >
              <div className="flex items-baseline justify-between gap-2">
                <div className="font-medium text-sm truncate">{c.name}</div>
                <div className="text-[10px] text-slate-500 tabular-nums shrink-0">{new Date(c.created_at).toLocaleDateString()}</div>
              </div>
              <div className="text-xs text-slate-500 truncate">{c.company || c.email}</div>
              <div className="text-xs text-slate-600 mt-1 truncate">{c.message}</div>
            </button>
          ))}
        </div>

        <div className="md:col-span-3 bg-white border border-slate-200 min-h-[70vh] p-6">
          {!selected ? (
            <div className="text-slate-400 text-sm">Select a message to view details.</div>
          ) : (
            <div data-testid="contact-detail">
              <div className="text-[10px] uppercase tracking-[0.28em] text-slate-500">From</div>
              <h2 className="font-display text-2xl tracking-tighter mt-1">{selected.name}</h2>
              <div className="text-sm text-slate-600 mt-1">
                {selected.email} {selected.company ? `· ${selected.company}` : ""}
              </div>
              {selected.phone && <div className="text-sm text-slate-500 mt-0.5">{selected.phone}</div>}
              <div className="mt-6 text-xs uppercase tracking-[0.2em] text-slate-500">Message</div>
              <p className="mt-2 text-slate-800 leading-relaxed whitespace-pre-wrap">{selected.message}</p>
              <div className="mt-8 text-xs text-slate-500 border-t border-slate-100 pt-4">
                Received {new Date(selected.created_at).toLocaleString()}
              </div>
            </div>
          )}
        </div>
      </div>
    </div>
  );
}
